export const API_LOGIN = 'App/Login::API_LOGIN';
export const API_CLUB_INFO = 'App/Login::API_CLUB_INFO';
export const CHANGE_CLUB = 'App/Login::CHANGE_CLUB';
export const API_GET_CLUBS = 'App/Login::API_GET_CLUBS';
export const SET_REGION = 'App/Login::SET_REGION';
